import React from "react";
import { motion } from "framer-motion";
import { Wordmark } from "../components/Wordmark";
import { useSeo } from "../lib/seo";

export default function NotFound() {
  useSeo("/404", { noindex: true });
  return (
    <div className="grain min-h-screen flex flex-col" style={{ backgroundColor: "#0E0A16" }} data-testid="notfound-page">
      <header className="px-6 md:px-10 h-[72px] flex items-center" style={{ borderBottom: "1px solid #2A2233" }}>
        <a href="/" data-testid="notfound-home-link"><Wordmark className="h-5" /></a>
      </header>

      <main className="flex-1 flex items-center">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="mx-auto max-w-[1400px] w-full px-6 md:px-10"
        >
          <div className="text-[11px] uppercase tracking-[0.35em] mb-6" style={{ color: "#C724B1" }}>
            Error 404
          </div>
          <h1
            className="font-display font-black leading-[1.02] tracking-tight mb-8"
            style={{ color: "#F4EEF7", fontSize: "clamp(2.5rem, 9vw, 8rem)" }}
          >
            Lost the thread.
          </h1>
          <p className="max-w-[46ch] text-lg leading-relaxed mb-12" style={{ color: "#9B8FAC" }}>
            This page doesn't exist — or it never did. Let's get you back to where the merch lives.
          </p>
          <a
            href="/"
            data-testid="notfound-back-btn"
            className="btn-sharp inline-block text-xs uppercase tracking-[0.22em] px-8 py-4 font-medium"
            style={{ backgroundColor: "#C724B1", color: "#F4EEF7" }}
            onMouseEnter={(e) => (e.currentTarget.style.transform = "translateY(-2px)")}
            onMouseLeave={(e) => (e.currentTarget.style.transform = "translateY(0)")}
          >
            Back to home
          </a>
        </motion.div>
      </main>
    </div>
  );
}
